var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLogo)?_c('router-link',{attrs:{"to":{ name: 'Home' }}},[(_vm.currentNameRoute !== 'Events')?_c('ImgSVG',{staticClass:"img",attrs:{"src":_vm.logoUrl,"alt":"ucall_logo_branco_svg"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }